import { useCallback } from 'react';

import Button from '@/components/Buttons/Button';
import { MAX_SELECTED_SYMBOLS } from '@/constants/constants';
import type { SymbolKey } from '@/entities/symbol';
import useSelectionFunctions from '@/features/SymbolSelector/hooks/useSelectionFunctions';
import { parseForwardCurveRowToSymbol } from '@/pages/Catalog/utils/parseForwardCurveRowToSymbol';
import type { CatalogItem } from '@/types/catalog';

import type { Table } from '@tanstack/react-table';

const SelectAllButton = ({
  table,
  isForwardCurves
}: {
  table: Table<CatalogItem>;
  isForwardCurves: boolean;
}) => {
  const getFwdCurveSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => parseForwardCurveRowToSymbol(row));
  }, [table]);
  const getSpotSymbols = useCallback(() => {
    return table.getFilteredRowModel().rows.flatMap(row => {
      return row.getValue<SymbolKey>('Symbol');
    });
  }, [table]);
  const { addSymbolsToSelection, addForwardCurvesToSelection } = useSelectionFunctions();
  const disabled = table.getRowModel().rows.length > MAX_SELECTED_SYMBOLS;
  return (
    <Button
      disabled={disabled}
      sx={{
        color: 'primary.main',
        ml: 1,
        px: 0.5,
        fontSize: 14,
        '&.Mui-disabled': {
          color: 'primary.main'
        }
      }}
      variant='text'
      onClick={() => {
        if (isForwardCurves) {
          addForwardCurvesToSelection(getFwdCurveSymbols());
        } else {
          addSymbolsToSelection(getSpotSymbols());
        }
      }}
    >
      Select All
    </Button>
  );
};
export default SelectAllButton;
